module.exports = __webpack_public_path__ + "static/mmi-logo-50fffbc1bab04cc35ee7f79ef6c68e0a.png";